
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tools/paragraph-rewriter",
      function () {
        return require("private-next-pages/app/tools/paragraph-rewriter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tools/paragraph-rewriter"])
      });
    }
  